import { render, staticRenderFns } from "./intervention_tab.vue?vue&type=template&id=162b4b98&"
import script from "./intervention_tab.vue?vue&type=script&lang=js&"
export * from "./intervention_tab.vue?vue&type=script&lang=js&"
import style0 from "./intervention_tab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports